import { IBaseResponseData, ISummary } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of summaries from the `/summary` endpoint.
 */
export interface ISummariesResponse extends IBaseResponseData {
  summaries: ISummary[]
}
